module.exports = __webpack_public_path__ + "media/images/smart_phone/order_menu_mypage/btn_my-page01-db8b232f9d778d5da5b700cd2f13bf26.png";